import script from "./WoononExtraProduct.vue?vue&type=script&lang=ts&setup=true"
export * from "./WoononExtraProduct.vue?vue&type=script&lang=ts&setup=true"

import "./WoononExtraProduct.vue?vue&type=style&index=0&id=447b9883&lang=less&scoped=true"

import exportComponent from "/var/build/production/buyers-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-447b9883"]])

export default __exports__